import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: var(--warning-yellow);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-right: 10px;
  }
  a {
    color: var(--warning-yellow) !important;
    font-weight: bold;
  }
  div {
    text-align: left;
    line-height: 1.25;
  }
`;

export default class extends React.Component {
  render() {
    return (
      <Wrapper>
        <img src="/media/icons/icon-warning.svg" />
        <div>{this.props.children}</div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/components/WarningMessage.tsx